module.exports = __webpack_public_path__ + "img/1.2ca60572.png";